export default __webpack_public_path__ + "static/media/monuments.9b1b11da.jpg";